module.exports = __webpack_public_path__ + "static/media/front.ae4c23b2.jpg";